<template>
  <div class="footer-mobile hide-for-large row-190-40">
    <ul class="footer-mobile-links">
      <li>
        <NuxtLink
          data-no-cursor
          :to="localePath({ name: 'sidri' })"
        >
          <span>{{ $t(`footer.main.ciders-and-spirits`) }}</span>
        </NuxtLink>
      </li>
      <li>
        <NuxtLink
          data-no-cursor
          :to="localePath({ name: 'alta-quota' })"
        >
          <span>{{ $t(`footer.main.high-altitude`) }}</span>
        </NuxtLink>
      </li>
      <li>
        <NuxtLink
          data-no-cursor
          :to="localePath({ name: 'savoir-faire' })"
        >
          <span>{{ $t(`footer.main.savoir-faire`) }}</span>
        </NuxtLink>
      </li>
      <li>
        <NuxtLink
          data-no-cursor
          :to="localePath({ name: 'contatti' })"
        >
          <span>{{ $t(`footer.main.contacts`) }}</span>
        </NuxtLink>
      </li>
    </ul>

    <div v-if="corporate?.generalInfo" class="footer-mobile-info">
      <div v-html="corporate?.generalInfo" />
    </div>

    <div class="footer-mobile-corporate">
      <div class="footer-main-corporate p-bottom-16px">
        <p v-html="$t('footer.main.copyright', { year: actualYear })" />
      </div>
      <div class="footer-credits flex is-justify-center p-bottom-16px">
        <nuxt-link
          :to="
            localePath({
              name: 'privacy-policy',
            })
          "
          ><span>{{ $t('footer.main.privacy') }}</span>
        </nuxt-link>
        <!-- <nuxt-link
          :to="
            localePath({
              name: 'cookie-policy',
            })
          "
          ><span>Cookie Policy</span>
        </nuxt-link> -->
      </div>
      <p>
        Designed by:
        <a
          v-if="!isErrorPage"
          target="_blank"
          rel="noopener"
          href="https://www.quamm.it/"
          >Quamm</a
        >
        <span v-else>Quamm</span>
      </p>
    </div>

    <div class="footer-main-logo">
      <!-- Logo completo di fallback -->
      <img
        v-if="false"
        src="@/assets/img/logos/logo-footer-completo.svg"
        :alt="runtimeConfig.public.siteName"
      />
      <img
        class="footer-main-logo-monogram"
        src="@/assets/img/logos/logo_inside_ring.svg"
        :alt="runtimeConfig.public.siteName"
      />
      <img
        class="footer-main-logo-ring"
        src="@/assets/img/logos/footer-ring-new.svg"
        :alt="runtimeConfig.public.siteName"
      />
    </div>
  </div>
</template>

<script>
export default {
  name: 'FooterSmall',
}
</script>

<script setup>
const runtimeConfig = useRuntimeConfig()
const actualYear = computed(() => new Date().getFullYear())

const switchLocalePath = useSwitchLocalePath()
const { locale, locales } = useI18n()

const props = defineProps({
  corporate: Object || null,
})

const isErrorPage = computed(() => !!useError().value)
</script>
